import { render, staticRenderFns } from "./CommentsList.vue?vue&type=template&id=38b372a2"
import script from "./CommentsList.vue?vue&type=script&lang=js"
export * from "./CommentsList.vue?vue&type=script&lang=js"
import style0 from "./CommentsList.vue?vue&type=style&index=0&id=38b372a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports